import RightArrow from '../../assets/icons/RightArrow.tsx';

interface Props {
  path: { id: string; name: string }[];
}

export function NavBar({ path }: Props) {
  if (!path || path.length === 0) return null;

  return (
    <nav
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '10px 24px',
        fontSize: 13,
        color: '#64748b',
        background: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
        flexShrink: 0,
        flexWrap: 'wrap',
      }}
    >
      {path.map((crumb, index) => (
        <span key={crumb.id} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {index > 0 && (
            <span style={{ color: '#cbd5e1', fontSize: 10 }}>
              <RightArrow />
            </span>
          )}
          <span
            style={{
              color: index === path.length - 1 ? '#1a202c' : '#64748b',
              fontWeight: index === path.length - 1 ? 600 : 400,
              whiteSpace: 'nowrap',
            }}
          >
            {crumb.name}
          </span>
        </span>
      ))}
    </nav>
  );
}
